import { useLazyQuery, useQuery } from '@apollo/client';
import { Box, Button, makeStyles, Typography } from '@material-ui/core';
import CustomLayout from 'component/layout/custom_layout';
import { WidgetCode } from 'component/popup/constant';
import WidgetPopup from 'component/popup/customize_popup';
import SliderChip from 'component/slider_chip';
import config from 'config';
import { cache } from 'graph_ql';
import { USER_DETAIL } from 'graph_ql/authentication/queries';
import { SEARCH_STYLE, SEARCH_STYLE_TYPE } from 'graph_ql/search/search_style';
import { useQueryData } from 'hooks/useQuery';
import { useCallback, useEffect, useMemo, useState } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { GET_HIGHLIGHT_COLLECTION } from 'graph_ql/highlight_collection/queries';
import HighlightCollection from './HighlightCollection';
import {
    getMe,
    setBodyShapeDefault,
    setBodyTypeDefault,
    setBudgetDefault,
    setEyeColorDefault,
    setFashionRestrictionDefault,
    setHairColorDefault,
    setMyBirthday,
    setPersonaDefault,
    setSkinToneDefault,
    setSkinUndertoneDefault,
    setStyleQuizLiked,
} from 'redux/authentication/user_detail';
import { getListAnswerPersonas } from 'redux/quiz_manager/personasSlice';
import { resetFilter, setPurposeFilter, setShowFilter } from 'redux/filter/filterSlice';
import { globalActions } from 'redux/global/global.slice';
import { RootState } from 'redux/store';
import { PATH } from 'routes/constant';
import themes from 'styles/themes';
import { buildFilter, buildStoreFilter } from 'utils/getQuerySearchStyles';
// import AvatarSlider from './AvatarSlider';
import CardSlider from './CardSlider';
import SectionHeading from './SectionHeading';
import AutoCompleteSearch from './auto_complete_search';
import SessionIntroCard from './session_intro_card';
import { EGENDER, EQuizId, quizContextType } from 'types/quiz';
import { GET_QUIZ_RESPONSE } from 'graph_ql/getQuiz/queries';
import { createFilterList, getAnsweredQuestions, renderItem, renderListStyleQuizLiked } from 'utils/convertListString';
import { Spinner } from 'react-bootstrap';
import { UpcomingStylingSessionsCard } from './upcoming-styling-sessions';
import utils from 'utils/utils';
import { STRINGS } from '../../../constants';
import { DiscoverYourStylesSession } from './discover-your-style-session';
import { WardrobeSection } from './wardrobe-section';

export enum ETypeStyle {
    RECOMMEND_STYLE = 'recommeded',
    PERSONALIZED_STYLE = 'stylist',
}

const useStyles = makeStyles((theme) => ({
    backgroundHome: {
        background: themes.palette.primary.light,
        boxShadow: 'none',
    },
    searchForm: {
        zIndex: 9,
        marginTop: 0,
        padding: '20px 24px 0 ',
    },
    searchIcon: {
        position: 'absolute',
        left: 10,
        top: 2,
        color: 'white',
    },
    loadingContainer: {
        display: 'flex',
        height: 'calc(100% - 56px)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    loader: {
        height: '2.5rem',
        width: '2.5rem',
    },
    content: {
        position: 'absolute',
        bottom: '20%',
        width: '100%',
        textAlign: 'center',
    },
    contentSurprise: {
        background: 'white',
        borderRadius: '29px ',
        width: 'auto',
        padding: '10px 50px',
        color: themes.palette.primary.main,
        fontWeight: 600,
        fontSize: 16,
        fontFamily: 'PoppinsRegular',
        border: 'none',
        zIndex: 1,
    },
    main: {
        height: '100%',
        overflowY: 'scroll',
        paddingBottom: '16px',
    },
    searchFormInputContainer: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        padding: '0',
    },
    searchFormInput: {
        background: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '29px ',
        border: `1px solid ${themes.palette.primary.main}`,
        backdropFilter: 'blur(8px) ',
        width: '100%',
        padding: '9px 45px',
        textAlign: 'center',
        zIndex: 1,
        caretColor: themes.palette.primary.main,
    },
    section: {
        background: themes.palette.common.white,
        marginTop: 12,
        marginBottom: 12,
        padding: '16px 0',
    },
    scheduleButton: {
        border: `1px solid #1A1A1A`,
        borderRadius: 29,
        color: '#1A1A1A',
        fontFamily: 'PoppinsRegular',
    },
    noPersonalizedStylesWrapper: {
        padding: 12,
        margin: 12,
        background: '#F9EADE',
        borderRadius: 12,
    },
    noPersonalizedStylesText: {
        color: '#1A1A1A',
        marginBottom: 12,
        fontFamily: 'PoppinsRegular',
    },
}));

function HomeCustomer() {
    const location = useLocation();
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const listStyleQuiz = useSelector((state: RootState) => state.userDetail.listStyleLiked);
    const loadingHome = useSelector((state: RootState) => state.global.loadingHome);
    const bodyShapeDefault = useSelector((state: RootState) => state.userDetail.bodyShapeDefault);
    const bodyTypeDefault = useSelector((state: RootState) => state.userDetail.bodyTypeDefault);
    const personaDefault = useSelector((state: RootState) => state.userDetail.personaDefault);
    const data = useQueryData(USER_DETAIL, null, true, true);
    const me = useSelector((state: RootState) => state.userDetail.me);
    const widgetStore = useSelector((state: RootState) => state.widget.store);
    useEffect(() => {
        if (data && data?.dataQuery) {
            dispatch(getMe(data.dataQuery.me));
        }
    }, [data, dispatch]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const userDetail = useMemo(() => data?.dataQuery?.me, [data]);

    //
    // ToDo: the search logic needs to move to common functions
    //       and need to be called from /recommendations and /search-style
    //       so that when these pages are refreshed we don't get zero results
    //
    const [isSearch, setIsSearch] = useState(false);
    const [value, setValue] = useState('');
    const [disable, setDisable] = useState(false);
    const [purposeOptions, setPurposeOptions] = useState<any>([]);
    const [showPopup, setShowPopup] = useState(false);
    const [recommendedStyles, setRecommendedStyles] = useState([]);
    const [personalizedStyles, setPersonalizedStyles] = useState([]);
    const [allQuizLoading, setAllQuizLoading] = useState(false);
    const [isQuizFetched, setIsQuizFetched] = useState(false);
    const spinnerLoading = useSelector((state: RootState) => state.global.spinnerLoading);

    const recommendedSearchVariables = useMemo(() => {
        cache.modify({
            fields: {
                locationsInRadius(existingTaskRefs, { readField }) {
                    return {};
                },
            },
        });
        const userGender = (userDetail?.gender || me?.gender || '')
            .toLowerCase()
            .replace('female', 'woman')
            .replace('male', 'man')
            .trim();
        const filters = buildFilter({
            categoryFilterList: listStyleQuiz,
            gender: userGender,
            filterStrDefault: `_consumersIdAndStatus: published`,
            bodyShapeDefault,
            bodyTypeDefault,
            personaDefault,
            isRecommended: true,
        });
        return {
            __typename: SEARCH_STYLE_TYPE.algolia_styles_recommend,
            index: config.algolia.algolia_prefix + 'styles',
            query: '',
            filters,
            hit: config.algoliaHitPerPage,
            page: 0,
            facets: [
                'price',
                'genders.value',
                'categories.name',
                'bodyShapes.title',
                'bodyTypes.title',
                'purposes.title',
                '_consumersIdAndStatus',
            ],
        };
    }, [listStyleQuiz, bodyShapeDefault, bodyTypeDefault, personaDefault, me?.gender, userDetail?.gender]);

    const personalizedSearchVariables = useMemo(() => {
        let filters = `_consumersIdAndStatus: ${
            me?.id || userDetail?.id
        } AND (status: private OR status: published OR status: unlisted)`;
        if (utils.isAppInWidgetMode()) {
            filters += ` AND (${buildStoreFilter(widgetStore)})`;
        }
        return {
            __typename: SEARCH_STYLE_TYPE.algolia_styles_personalized,
            index: config.algolia.algolia_prefix + 'styles',
            query: '',
            filters,
            hit: 10,
            page: 0,
            facets: ['_consumersIdAndStatus'],
        };
    }, [widgetStore, me, userDetail]);

    const { loading: styleLoading } = useQuery(SEARCH_STYLE, {
        variables: recommendedSearchVariables,
        onCompleted(response) {
            setRecommendedStyles(response?.locationsInRadius?.hits);
        },
        skip: !me?.gender || allQuizLoading,
        fetchPolicy: 'cache-first',
    });

    const { loading: personalizedLoading } = useQuery(SEARCH_STYLE, {
        variables: personalizedSearchVariables,
        onCompleted(response) {
            setPersonalizedStyles(response?.locationsInRadius?.hits);
        },
        skip: Boolean(!location.pathname.includes(PATH.HOME)),
        fetchPolicy: 'cache-first',
    });

    const { data: highlightCollectionData } = useQuery(GET_HIGHLIGHT_COLLECTION, {
        variables: {
            input: {
                gender: me?.gender?.toUpperCase(),
            },
        },
        skip: !me?.gender,
    });

    const handleSearch = async (valueSearch) => {
        await dispatch(resetFilter());
        history.push({
            pathname: PATH.SEARCH_STYLES,
            search: `?search=${valueSearch}`,
        });
    };
    const handleKeyDown = (e, valueSearch) => {
        if (e.key === 'Enter') {
            setDisable(true);
            handleSearch(valueSearch);
            dispatch(setPurposeFilter(null));
        }
    };

    const handleRecommendedStyleClick = () => {
        dispatch(setPurposeFilter(null));
        history.push(PATH.FEED, { title: 'Style Recommendations' });
    };
    const handlePersonalizedStyleClick = () => {
        dispatch(setPurposeFilter(null));
        history.push(PATH.PERSONALIZED_STYLES, { title: 'Personalized Styles' });
    };
    const handleClickPurposeSuggestion = (purposeOption) => {
        history.push(PATH.SEARCH_STYLES, { title: purposeOption?.title });
        dispatch(setPurposeFilter(purposeOption));
        dispatch(setShowFilter(true));
    };

    const handleStyleItemClick = (style, styleType) => {
        dispatch(setPurposeFilter(null));
        switch (styleType) {
        case ETypeStyle.PERSONALIZED_STYLE:
            return history.push(PATH.PERSONALIZED_STYLES, {
                title: 'Personalized Styles',
                taffiId: style?.taffiId,
            });

        case ETypeStyle.RECOMMEND_STYLE:
            return history.push(PATH.FEED, {
                title: 'Style Recommendations',
                taffiId: style?.taffiId,
            });
        default:
            return;
        }
    };

    const navigateToAmira = () => {
        history.push(PATH.STYLE_ASSISTANT);
    };

    useEffect(() => {
        cache.modify({
            fields: {
                locationsInRadius(existingTaskRefs, { readField }) {
                    return {};
                },
            },
        });
    }, []);

    const searchVariables = useMemo(() => {
        let index = 'styles';

        return {
            __typename: SEARCH_STYLE_TYPE.algolia_styles,
            index: config.algolia.algolia_prefix + index,
            query: '',
            hit: config.algoliaHitPerPage,
            page: 0,
            facets: ['purposes.title'],
        };
    }, []);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { loading: purposeLoading } = useQuery(SEARCH_STYLE, {
        variables: searchVariables,
        onCompleted(response) {
            const { facets, page } = response.locationsInRadius;
            if (page === 0) {
                dispatch(resetFilter());
                for (const facet of facets) {
                    if (facet.name === 'purposes.title') {
                        const purposeList = Object.keys(facet.data).map((item) => {
                            return {
                                title: item,
                                value: item,
                                isActive: false,
                            };
                        });
                        setPurposeOptions(purposeList);
                    }
                }
            }
        },
        skip: Boolean(!location.pathname.includes(PATH.HOME)),
        fetchPolicy: 'cache-first',
    });

    const [getQuizResponse] = useLazyQuery(GET_QUIZ_RESPONSE, {
        onError(error) {
            console.log('error', error);
        },
    });

    const getQuizVariable = useCallback(
        (quizId: EQuizId) => {
            if (me?.id) {
                return {
                    variables: {
                        input: {
                            quizId: quizId,
                            contextType: quizContextType,
                            contextId: quizId,
                            userId: me?.id,
                        },
                    },
                };
            }
        },
        [me?.id],
    );

    const updateAnswersOnRedux = (item) => {
        const { answers, questions } = item;
        switch (item.id) {
        case EQuizId.MY_BIRTHDAY_QUIZ:
            dispatch(setMyBirthday(answers?.birthday_question.value));
            break;
        case EQuizId.PERSONAS_MALE_QUIZ:
            dispatch(getListAnswerPersonas(renderItem(answers?.personas_male_question?.value)));
            dispatch(setPersonaDefault(createFilterList(answers?.personas_male_question?.value)));
            break;
        case EQuizId.PERSONAS_FEMALE_QUIZ:
            dispatch(getListAnswerPersonas(renderItem(answers?.personas_female_question?.value)));
            dispatch(setPersonaDefault(createFilterList(answers?.personas_female_question?.value)));
            break;
        case EQuizId.BODY_SHAPE:
            dispatch(setBodyShapeDefault(answers?.body_shape_question.value));
            break;
        case EQuizId.BODY_TYPE:
            dispatch(setBodyTypeDefault(answers?.body_type_question.value));
            break;
        case EQuizId.SKIN_TONE:
            dispatch(setSkinToneDefault(answers?.skintone_question));
            break;
        case EQuizId.SKIN_UNDERTONE:
            dispatch(setSkinUndertoneDefault(answers?.skin_undertone_question));
            break;
        case EQuizId.HAIR_COLOR:
            dispatch(setHairColorDefault(answers?.hair_color_question));
            break;
        case EQuizId.EYE_COLOR:
            dispatch(setEyeColorDefault(answers?.eye_color_question));
            break;
        case EQuizId.STYLE_QUIZ_MAN:
            dispatch(setStyleQuizLiked(renderListStyleQuizLiked(answers, questions)));
            break;
        case EQuizId.STYLE_QUIZ_WOMAN:
            dispatch(setStyleQuizLiked(renderListStyleQuizLiked(answers, questions)));
            break;
        case EQuizId.FASHION_RESTRICTION_QUIZ_MAN:
        case EQuizId.FASHION_RESTRICTION_QUIZ_WOMAN:
            dispatch(setFashionRestrictionDefault(getAnsweredQuestions(answers, questions)));
            break;
        case EQuizId.BUDGET_MAN_QUIZ:
            dispatch(setBudgetDefault(getAnsweredQuestions(answers, questions)));
            break;
        default:
            break;
        }
    };

    useEffect(() => {
        if (loadingHome) {
            setTimeout(() => {
                dispatch(globalActions.setSpinnerLoading(spinnerLoading.filter((item) => item !== 'loadingHome')));
                dispatch(globalActions.setLoadingHome(false));
            }, 1000);
        }
    }, [spinnerLoading, loadingHome, dispatch]);

    const callQuizList = () => {
        let quizzes: any = [];
        if (me.gender === EGENDER.MALE) {
            quizzes = [
                getQuizResponse(getQuizVariable(EQuizId.MY_BIRTHDAY_QUIZ)),
                getQuizResponse(getQuizVariable(EQuizId.PERSONAS_MALE_QUIZ)),
                getQuizResponse(getQuizVariable(EQuizId.BODY_SHAPE)),
                getQuizResponse(getQuizVariable(EQuizId.BODY_TYPE)),
                getQuizResponse(getQuizVariable(EQuizId.SKIN_TONE)),
                getQuizResponse(getQuizVariable(EQuizId.SKIN_UNDERTONE)),
                getQuizResponse(getQuizVariable(EQuizId.EYE_COLOR)),
                getQuizResponse(getQuizVariable(EQuizId.STYLE_QUIZ_MAN)),
                getQuizResponse(getQuizVariable(EQuizId.FASHION_RESTRICTION_QUIZ_MAN)),
                getQuizResponse(getQuizVariable(EQuizId.BUDGET_MAN_QUIZ)),
            ];
        } else {
            quizzes = [
                getQuizResponse(getQuizVariable(EQuizId.MY_BIRTHDAY_QUIZ)),
                getQuizResponse(getQuizVariable(EQuizId.PERSONAS_FEMALE_QUIZ)),
                getQuizResponse(getQuizVariable(EQuizId.BODY_SHAPE)),
                getQuizResponse(getQuizVariable(EQuizId.BODY_TYPE)),
                getQuizResponse(getQuizVariable(EQuizId.SKIN_TONE)),
                getQuizResponse(getQuizVariable(EQuizId.SKIN_UNDERTONE)),
                getQuizResponse(getQuizVariable(EQuizId.HAIR_COLOR)),
                getQuizResponse(getQuizVariable(EQuizId.EYE_COLOR)),
                getQuizResponse(getQuizVariable(EQuizId.STYLE_QUIZ_WOMAN)),
                getQuizResponse(getQuizVariable(EQuizId.FASHION_RESTRICTION_QUIZ_WOMAN)),
                getQuizResponse(getQuizVariable(EQuizId.BUDGET_WOMAN_QUIZ)),
            ];
        }
        setAllQuizLoading(true);
        setIsQuizFetched(true);
        dispatch(globalActions.setLoadingHome(true));
        Promise.all(quizzes)
            .then((value) => {
                let quizList = value.map((item) => item.data.getQuizResponse);
                quizList.forEach((item) => {
                    if (item?.id && !_isEmpty(item?.answers)) {
                        updateAnswersOnRedux(item);
                    }
                });
                setAllQuizLoading(false);
            })
            .catch((e) => {
                setAllQuizLoading(false);
                console.log('quiz error', e);
            });
    };

    useEffect(() => {
        if (
            me?.id &&
            !allQuizLoading &&
            !isQuizFetched &&
            (!bodyShapeDefault.length || !listStyleQuiz.length || !personaDefault.length || !bodyTypeDefault.length)
        ) {
            callQuizList();
        } else if (
            bodyShapeDefault.length &&
            listStyleQuiz.length &&
            personaDefault.length &&
            bodyTypeDefault.length &&
            spinnerLoading?.includes('loadingHome')
        ) {
            setTimeout(() => {
                dispatch(globalActions.setSpinnerLoading(spinnerLoading.filter((item) => item !== 'loadingHome')));
            }, 2000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        me,
        bodyShapeDefault,
        bodyTypeDefault,
        listStyleQuiz,
        personaDefault,
        loadingHome,
        allQuizLoading,
        isQuizFetched,
        spinnerLoading,
    ]);

    return (
        <div id="control-height" style={{ height: '100vh' }}>
            <CustomLayout showSideBarBtn={true} className={classes.backgroundHome}>
                <div id="main" className={classes.main}>
                    {!allQuizLoading ? (
                        <>
                            <div className={classes.searchForm}>
                                <AutoCompleteSearch
                                    disable={disable || allQuizLoading}
                                    setDisable={setDisable}
                                    handleKeyDown={handleKeyDown}
                                    value={value}
                                    setIsSearch={setIsSearch}
                                    setValue={setValue}
                                    isSearch={isSearch}
                                    handleSearch={handleSearch}
                                />
                            </div>
                            {purposeLoading ? (
                                <div className="d-flex justify-content-center mt-3">
                                    <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />
                                </div>
                            ) : (
                                purposeOptions &&
                                purposeOptions.length > 0 && (
                                    <SliderChip
                                        listChip={purposeOptions}
                                        handleClick={handleClickPurposeSuggestion}
                                        handleOpenWidget={() => setShowPopup(true)}
                                    />
                                )
                            )}
                        </>
                    ) : (
                        <div className="d-flex justify-content-center mt-3">
                            <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />
                        </div>
                    )}
                    <div>
                        {highlightCollectionData && !utils.isAppInWidgetMode() ? (
                            <HighlightCollection highlightCollectionData={highlightCollectionData} />
                        ) : null}
                        <SessionIntroCard />

                        {/* {stylists.length || stylistsLoading ? (
                            <Box className={classes.section} style={{ marginTop: 14 }}>
                                <SectionHeading title="Featured Stylists" onClick={handleStylistHeadingClick} />
                                {stylists.length ? (
                                    <AvatarSlider list={stylists} onProfileItemClick={handleClickStylist} />
                                ) : stylistsLoading ? (
                                    <div className="d-flex justify-content-center">
                                        <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />
                                    </div>
                                ) : null}
                            </Box>
                        ) : null} */}
                        <UpcomingStylingSessionsCard />
                        {(recommendedStyles.length || styleLoading || allQuizLoading) && !utils.isAppInWidgetMode() ? (
                            <Box className={classes.section}>
                                <SectionHeading
                                    title="Amira Recommended Styles For You"
                                    onClick={handleRecommendedStyleClick}
                                />
                                {recommendedStyles.length ? (
                                    <CardSlider
                                        list={recommendedStyles}
                                        onItemClick={handleStyleItemClick}
                                        styleType={ETypeStyle.RECOMMEND_STYLE}
                                    />
                                ) : styleLoading || allQuizLoading ? (
                                    <div className="d-flex justify-content-center">
                                        <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />
                                    </div>
                                ) : null}
                            </Box>
                        ) : null}
                        <DiscoverYourStylesSession />
                        <Box className={classes.section}>
                            <SectionHeading
                                title="Personalized Styles For You"
                                onClick={handlePersonalizedStyleClick}
                                shouldShowArrow={Boolean(personalizedStyles.length)}
                            />
                            {personalizedStyles.length ? (
                                <CardSlider
                                    list={personalizedStyles}
                                    onItemClick={handleStyleItemClick}
                                    styleType={ETypeStyle.PERSONALIZED_STYLE}
                                />
                            ) : personalizedLoading ? (
                                <div className="d-flex justify-content-center">
                                    <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />
                                </div>
                            ) : (
                                <Box className={classes.noPersonalizedStylesWrapper}>
                                    <Typography variant="body2" className={classes.noPersonalizedStylesText}>
                                        {STRINGS.HOME_NO_PERSONALIZED_STYLES}
                                    </Typography>
                                    <Button
                                        variant="outlined"
                                        onClick={navigateToAmira}
                                        className={classes.scheduleButton}
                                    >
                                        {STRINGS.ASK_AMIRA_NOW}
                                    </Button>
                                </Box>
                            )}
                        </Box>
                        <WardrobeSection />
                    </div>
                </div>
            </CustomLayout>
            {showPopup && (
                <WidgetPopup
                    titlePopup={'Style Purpose'}
                    widgetCode={WidgetCode.PurposeSuggestionWidget}
                    listOptions={purposeOptions}
                    onClose={() => setShowPopup(false)}
                />
            )}
        </div>
    );
}

export default HomeCustomer;
